import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  GET_THONG_BAO,
  UPDATE_THONG_BAO,
  GET_LIST_THONG_BAO,
} from 'actions/ThongBao/actionTypes';
import {
  getThongBaoSuccess,
  getThongBaoFailure,
  updateThongBaoSuccess,
  updateThongBaoFailure,
  getListThongBaoSuccess,
  getListThongBaoFailure,
  setShowThongBao,
} from 'actions/ThongBao';
import ThongBaoApi from 'service/thongBaoApi';
import { pushNotification } from 'utils/notifications';
function* getListThongBao(action) {
  try {
    const response = yield call(ThongBaoApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListThongBaoSuccess(response.data));
      if (response.data.NotiId) yield put(setShowThongBao());
    } else {
      pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
      yield put(getListThongBaoFailure());
    }
  } catch (error) {
    pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
    yield put(getListThongBaoFailure());
  }
}
function* getThongBao(action) {
  try {
    const response = yield call(ThongBaoApi.chiTiet, action.dataSearch);
    if (response.ok) {
      yield put(getThongBaoSuccess(response.data));
    } else {
      pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
      yield put(getThongBaoFailure());
    }
  } catch (error) {
    pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
    yield put(getThongBaoFailure());
  }
}

function* updateThongBao(action) {
  try {
    const response = yield call(ThongBaoApi.updateThongBao, action.dataSearch);
    if (response.ok) {
      yield put(updateThongBaoSuccess(response.data));
    } else {
      pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
      yield put(updateThongBaoFailure());
    }
  } catch (error) {
    pushNotification('Lỗi xảy ra', 'error', 'TOP_CENTER', 1000);
    yield put(updateThongBaoFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_THONG_BAO, getThongBao);
  yield takeLatest(GET_LIST_THONG_BAO, getListThongBao);
  yield takeLatest(UPDATE_THONG_BAO, updateThongBao);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
